import { render, staticRenderFns } from "./promotionCategoryLists.vue?vue&type=template&id=65d0049c&scoped=true&"
import script from "./promotionCategoryLists.vue?vue&type=script&lang=js&"
export * from "./promotionCategoryLists.vue?vue&type=script&lang=js&"
import style0 from "./promotionCategoryLists.vue?vue&type=style&index=0&id=65d0049c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d0049c",
  null
  
)

export default component.exports